<div id="rollin" class="mt-4">
    <form [ngrxFormState]="form" *ngIf="form$|async; let form" class="w-100" autocomplete="off" role="presentation">
        <div class="content">

            <div class="mb-1 super-fund position-relative col-12 p-0 add-super-fund-form-container" *ngFor="
                                let item of form.controls.superFundList
                                  .controls;
                                let i = index;
                                trackBy: trackByFn;
                                let last = last
                              ">
                <div class="close-icon" (click)="onRemoveSuperFundClick(i)" *ngIf="form.value.superFundList.length > 1">
                    <mat-icon>close</mat-icon>
                </div>

                <!-- form to enter super details before adding a new one -->
                <ng-container>
                    <div class="row" *ngIf="item.value.usi">
                        <div class="col col-md-12 p-0">
                            <app-readonly title="Name of the Fund" [value]="item.value.nameOfSuperFund">
                            </app-readonly>
                        </div>
                    </div>
                    <div class="row" *ngIf="item.value.usi">
                        <div class="col col-md-12 p-0">
                            <app-readonly title="Abn of the fund" [value]="item.value.abn">
                            </app-readonly>
                        </div>
                    </div>
                    <div class="row" *ngIf="item.value.usi">
                        <div class="col col-md-12 p-0">
                            <app-readonly title="Unique superannuation identifier (usi)" [value]="item.value.usi">
                            </app-readonly>
                        </div>
                    </div>
                    <div class="row" *ngIf="item.value.usi">
                        <div class="col col-md-12 p-0 pt-1">
                            <app-entry class="entry-dark-bg" title="Member number"
                                [control]="item.controls.memberNumber">
                            </app-entry>
                        </div>
                    </div>
                    <div class="row" *ngIf="item.value.usi">
                        <div class="col col-md-12 p-0">
                            <app-entry-radio class="transfer-options" [customList]="transferOptions$"
                                [control]="item.controls.wholeAmount"></app-entry-radio>
                        </div>
                    </div>
                    <div class="row" *ngIf="item.value.wholeAmount == 2" appanimatecss>
                        <div class="col col-md-12 p-0 pt-3">
                            <app-entry-number class="entry-dark-bg" title="Amount to transfer"
                                [control]="item.controls.amountToTransfer">
                            </app-entry-number>
                        </div>
                    </div>
                </ng-container>
            </div>

            <!-- component to search for super fund -->
            <div class="col col-md-12 p-0" *ngIf="canSearch$|async">
                <app-superannuation-provider-search (onSelected)="onSelectedOption($event)">
                </app-superannuation-provider-search>
            </div>

            <div class="col-12 mt-3 p-0" *ngIf="form$ | async; let form">
                <div class="d-flex">
                    <app-button class="center add-superfund" title="Add another super fund" color="light"
                        [isDisabled]="!(canAddNewSuperfund$|async)" (onClick)="onAddSuperFundClick()">
                    </app-button>
                </div>
            </div>
            <div class="col-12 p-0">
                <div class="mt-3 description footer important">
                    <div class="note">
                        <h5>This is important.</h5>
                        <p>
                            You are giving permission to Verve Super to transfer the specified balance from the super
                            fund(s) that you have indicated above into your Verve Super account and authorise the
                            superannuation provider of each fund to give effect to this transfer. You discharge the
                            provider
                            of your transferring fund from all further liability in respect of the benefits paid and
                            transferred.

                        </p>
                        <p>
                            You may ask your superannuation provider for information about any fees or charges that may
                            apply, or any other information about the effect this transfer may have on your benefits,
                            and
                            you have obtained or do not require such information.

                        </p>
                        <p>
                            You understand that if you transfer the whole balance from the super fund(s) you have
                            indicated
                            above, the accounts you have with those super funds will be closed and you will lose any
                            benefits and insurance cover you had with those funds. Please consider the impact of any
                            loss of
                            insurance cover. You can apply for a transfer of cover before transferring over, or apply
                            for
                            new insurance with Verve Super (subject to eligibility). If you have a pre-existing
                            condition,
                            it may be difficult for you to obtain any or equal cover with another provider. <a
                                href="https://vervesuper.com.au/contact-us" target="_blank">Contact us</a> for
                            more information.

                        </p>
                        <p>
                            We will send you a confirmation email when the funds have arrived in your Verve Super
                            account.
                        </p>
                        <app-checkbox class="entry-dark-bg" title="I have read, understood and agree to the above"
                            [control]="form.controls.rolloverAgreement">
                        </app-checkbox>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-bottom row mt-3 mb-4 col-12 p-0">
            <div class="col-12 col-md-12 p-0">
                <div class="d-flex flex-row justify-content-between">
                    <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
                    </app-button>
                    <app-button class="custom" title="Next" [isDisabled]="(isLoading$ | async) || form.isInvalid"
                        loading icon="east" (onClick)="goNext()">
                    </app-button>
                </div>
                <a class="float-right mt-2 click" (click)="goNextWithNone()">
                    Or continue without transferring
                </a>
            </div>
        </div>
        <div class="footer footer-mobile col-12 mt-5">
            <ng-template class="" [ngTemplateOutlet]="FooterStep5"></ng-template>
        </div>
    </form>

    <ng-template #FooterStep5>
        <h5>
            Need help?
            <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
        </h5>
        <p>
            All information is of a general nature only. It is important to do your own
            research and consider things like fees, investment performance, insurance,
            risk, and alignment with your values when considering if Verve Super is
            right for you. Consider seeking financial advice. When considering
            performance, past performance is not indicative of future performance.
            <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
        </p>
    </ng-template>
</div>